import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import { transformedColor } from '../../../constants/themehelper';

var TAGPickerButtonGroup = function TAGPickerButtonGroup(props) {
  return React.createElement(Box, null, React.createElement(DialogActions, {
    sx: {
      justifyContent: 'center'
    }
  }, props.clearable && React.createElement(Button, {
    autoFocus: true,
    onClick: props.onClear,
    sx: {
      marginRight: 'auto',
      color: props.color
    }
  }, props.clearText), props.showTodayButton && React.createElement(Button, {
    autoFocus: true,
    onClick: props.onSetToday,
    sx: props.clearable ? {
      marginLeft: 'auto',
      color: transformedColor(props.color)
    } : {
      marginRight: 'auto',
      color: transformedColor(props.color)
    }
  }, props.todayText), React.createElement(Button, {
    autoFocus: true,
    onClick: props.onDismiss,
    sx: {
      marginLeft: 'auto',
      color: transformedColor(props.color)
    }
  }, props.cancelText), React.createElement(Button, {
    onClick: props.onAccept,
    autoFocus: true,
    sx: {
      marginLeft: 'auto',
      color: transformedColor(props.color)
    }
  }, props.okText)));
};

export default TAGPickerButtonGroup;